import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { defaultSettings } from "css/defaultAntStyles";
import { useSelector } from "react-redux";
import { selectMainState } from "AppStore/Slices/MainSlice/MainSlice";
import { selectUser } from "AppStore/Slices/UserSlice/UserSlice";

export const MyLoader = ({
  isFull = false,
  size = 82,
  centered = false,
  margin = "20px 0",
}) => {
  const isDark = defaultSettings.navTheme === "realDark";
  if (isFull) {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: isDark ? "#141414" : "#ffffff",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",

            fontWeight: 700,
            fontSize: 22,
            lineHeight: 1,

            padding: "10px 22px",
            border: `3px solid ${defaultSettings.colorPrimary}`,
            borderRadius: 10,

            color: defaultSettings.colorPrimary,
            letterSpacing: 0.5,
          }}
        >
          E-Blank
        </span>

        <Spin
          indicator={
            <LoadingOutlined
              spin
              style={{
                fontSize: size,
                color: defaultSettings.colorPrimary,
              }}
            />
          }
        />
      </div>
    );
  }

  return (
    <Spin
      style={
        centered && {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: margin,
        }
      }
      indicator={
        <LoadingOutlined
          spin
          style={{
            fontSize: size,
            color: defaultSettings.colorPrimary,
          }}
        />
      }
    />
  );
};

export const FullLoaderPage = () => {
  const { isRefreshing } = useSelector(selectUser);
  const { isLoading } = useSelector(selectMainState);

  if (isLoading && isRefreshing) {
    return <MyLoader isFull={true} />;
  }
  if (isLoading) {
    return <MyLoader isFull={true} />;
  }
};
